/**
 * Summary: Within `navlist.liquid`, we leverage the liquid variables `menu_item.active`, and continue to do so, but this has limitations as we don't always have unique urls for each tab. For instance:
 * 'journal' -> `/blogs/journal`
 * 'podcast' -> `/blogs/journal/tagged/magculture-audio`
 *  Therefore, this additional javascript class handles these specific mappings manually
 **/

export const navigationState = () => {
  const { href } = window.location;

  if (window.innerWidth < 1024) {
    const navList = document
      .querySelector('.mobile-nav-content')
      .querySelector('[data-navmenu]');
    updateSelectedTab(navList, href);
  } else {
    const navList = document
      .querySelector('.site-navigation')
      .querySelector('[data-navmenu]');
    updateSelectedTab(navList, href);
  }

  edgeCaseMappings(href);
};

const updateSelectedTab = (navList, href) => {
  const navListItems = Array.from(navList.children);

  // Check the current URL and see if there are any matching definititions within the nav (as an href element)
  if (navListItems) {
    navListItems.forEach((navListItem) => {
      const hasValidNavItem = navListItem.classList.contains('navmenu-item');

      if (hasValidNavItem) {
        const navList = navListItem.querySelector('a');
        if (href === navList.href) {
          setColor(navList);
        }
      }
    });
  }
};

// There are some edge cases that have been manually altered to highlight the active tab
const edgeCaseMappings = (selectedHref) => {
  if (
    selectedHref.includes('products') ||
    selectedHref.includes('collections')
  ) {
    const shopLinks = getShopNavLinks();
    shopLinks.forEach((shopLink) => {
      setColor(shopLink.querySelector('a'));
    });
  }
};

const getShopNavLinks = () => {
  return document.querySelectorAll('[data-pxl-navmenu-shop]');
};

const setColor = (element) => {
  element.style.color = '#e20613';
};
